
export const drawerStyles = {
    components: {

        // Styling the <Input> Element
        Drawer: {
            baseStyle: {



            },


        },
    },
};
